<div class="rvp">
  <!-- Full-screen map -->
  <div class="rvp-map">
    <div id="test" (mouseleave)="hoveredRoutePoint = null">
      <div class="route-point-tip" role="tooltip" *ngIf="hoveredRoutePoint"
        [style.left.px]="routeTipX" [style.top.px]="routeTipY">
        <div><i class="fa fa-clock-o" aria-hidden="true"></i> زمان: {{ (hoveredRoutePoint.strTime ?? '—') | faNum }}</div>
        <div><i class="fa fa-tachometer" aria-hidden="true"></i> سرعت: {{ (hoveredRoutePoint.iSpeed ?? '—') | faNum }} km/h</div>
      </div>
    </div>
  </div>

  <!-- Top floating bar -->
  <div class="rvp-top">
    <div class="glass top-pill">
      <button class="icon-btn back" (click)="navigateBack()" title="بازگشت">
        <i class="fa fa-arrow-right"></i>
      </button>
      <div class="top-titles top-stats">
        <span class="top-stat" *ngIf="totalDistance" [attr.data-tip]="'پیمایش (km)'">
          <i class="fa fa-road"></i><b>{{ totalDistance | faNum }}<small>km</small></b>
        </span>
        <span class="top-stat" *ngIf="totalTime" [attr.data-tip]="'زمان کل'">
          <i class="fa fa-clock-o"></i><b>{{ totalTime | faNum }}</b>
        </span>
      </div>
      <div class="top-divider" *ngIf="carName"></div>
      <div class="top-car" *ngIf="carName">
        <span class="car-dot"><i class="fa fa-car"></i></span>
        <span>{{ carName | faNum }}<small *ngIf="carPlate">{{ formatPlate(carPlate) | faNum }}</small></span>
      </div>
      <button class="icon-btn ghost" (click)="openGuide()" title="راهنما">
        <i class="fa fa-question"></i>
      </button>
    </div>
  </div>

  <!-- Floating playback panel -->
  <aside class="rvp-side" *ngIf="isPlaybackMode">
    <div class="glass side-pill">
      <div class="live-inline" *ngIf="!isFuelTanker">
        <span class="top-stat" *ngIf="currentTime != undefined"><i class="fa fa-clock-o"></i><b>{{ currentTime | faNum }}</b></span>
        <span class="top-stat speed" *ngIf="currentSpeed != undefined"><i class="fa fa-tachometer"></i><b>{{ currentSpeed | faNum }}<small>km/h</small></b></span>
      </div>
      <div class="live-inline" *ngIf="isFuelTanker && currentDateTime">
        <span class="top-stat"><i class="fa fa-clock-o"></i><b>{{ currentDateTime | faNum }}</b></span>
      </div>
      <div class="live-inline" *ngIf="isTankerRoute || isFuelTanker">
        <span class="top-stat t3" *ngIf="tankerFill != 0"><i class="fa fa-tint"></i><b>{{ tankerFill.toLocaleString() | faNum }}<small>%</small></b></span>
        <span class="top-stat t4" *ngIf="tankerVolume != 0"><i class="fa fa-database"></i><b>{{ tankerVolume.toLocaleString() | faNum }}</b></span>
      </div>
    </div>

    <!-- Tanker -->
    <div class="tanker-mini" *ngIf="isPlaybackMode && isTankerRoute">
      <div class="tanker-mini-head"><span>سطح مخزن تانکر</span><b>{{ (tankerFill | faNum) + '%' }}</b></div>
      <div class="tanker-stage">
        <div class="tanker-truck">
          <div class="tank-box">
            <div class="tank-fill" [style.height.%]="tankerHeight" [class.is-empty]="tankerHeight <= 0"></div>
          </div>
          <img src="../../../assets/Img/tankwagen.png" alt="تانکر">
          <div class="tank-badge">{{ (tankerFill | faNum) + '%' }}</div>
        </div>
      </div>
      <div class="progress"><b [style.width.%]="tankerFill"></b></div>
    </div>

    <!-- Fuel tank -->
    <div class="tanker-mini" *ngIf="isPlaybackMode && isFuelTanker">
      <div class="tanker-mini-head"><span><i class="fa fa-tint"></i> سطح باک سوخت</span><b>{{ (tankerFill | faNum) + '%' }}</b></div>
      <div class="tanker-stage oil-stage">
        <div class="image-wrapper">
          <img src="../../../assets/Img/oil-1.png" class="base-image" alt="باک">
          <img src="../../../assets/Img/oil-2.png" class="color-image" alt="سوخت">
          <div class="top-mask" [style.height.%]="100 - tankerHeight"></div>
        </div>
      </div>
      <div class="progress"><b [style.width.%]="tankerFill"></b></div>
    </div>
  </aside>

  <!-- Right tool rail -->
  <div class="glass rvp-rail" [class.tanker-rail]="isPlaybackMode && (isTankerRoute || isFuelTanker)">
    <button class="rail-btn danger" [disabled]="isExportingPdf" (click)="exportMapPdf()" data-tip="خروجی PDF نقشه">
      <i class="fa fa-file-pdf-o"></i>
    </button>
    <button class="rail-btn" (click)="toggleBaseMap()" data-tip="تغییر نوع نقشه">
      <img src="../../../assets/Img/layer-icon.png" alt="لایه">
    </button>
    <div class="rail-sep"></div>
    <button class="rail-btn accent" (click)="reloadRoute()" data-tip="بارگذاری مجدد">
      <i class="fa fa-refresh"></i>
    </button>
  </div>

  <!-- Bottom dock: normal mode -->
  <div class="rvp-dock" *ngIf="!isPlaybackMode">
    <div class="glass dock">
      <div class="dock-date" [formGroup]="dateForm" [attr.data-tip]="'تاریخ مسیر: ' + (dateForm.get('strSDate')?.value | faNum)">
        <span class="abtn c date-ic"><i class="fa fa-calendar"></i></span>
        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
          (dateOnSelect)="onRouteDateSelect($event)" [dateInitValue]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
          <input type="text" formControlName="strSDate" class="dock-date-input" placeholder="انتخاب تاریخ" readonly />
        </ng-persian-datepicker>
      </div>
      <div class="dock-sep"></div>
      <button class="abtn p" *ngIf="routeLength > 1" (click)="startPlayback(0)" data-tip="شبیه‌سازی حرکت">
        <i class="fa fa-play-circle"></i>
      </button>
      <button class="abtn g" data-bs-toggle="modal" data-bs-target="#info" data-tip="نمایش اطلاعات">
        <i class="fa fa-table"></i>
      </button>
      <button class="abtn c" *ngIf="access?.bReCalDistance" (click)="recalculateDistance()" data-tip="محاسبه نرم‌افزاری فاصله">
        <i class="fa fa-calculator"></i>
      </button>
      <button class="abtn d" *ngIf="routeLength > 1 && showArrowButton" (click)="showDirectionArrows()" data-tip="نمایش جهت‌نما">
        <i class="fa fa-location-arrow"></i>
      </button>
      <button class="abtn d" *ngIf="routeLength > 1 && !showArrowButton" (click)="hideDirectionArrows()" data-tip="حذف جهت‌نما">
        <i class="fa fa-eye-slash"></i>
      </button>
    </div>
  </div>

  <!-- Bottom dock: playback mode -->
  <div class="rvp-dock" *ngIf="isPlaybackMode">
    <div class="glass-dark player">
      <div class="player-time player-time-top" *ngIf="rangeEndTime">
        از <strong>{{ rangeStartTime | faNum }}</strong> تا <strong>{{ rangeEndTime | faNum }}</strong>
      </div>
      <ngx-slider [(value)]="sliderStart" [(highValue)]="sliderEnd" [options]="sliderOptions"
        (valueChange)="onRangeStartChange($event)" (highValueChange)="onRangeEndChange($event)"></ngx-slider>
      <div [formGroup]="lineForm" class="player-controls">
        <ng-container *ngIf="showPlaybackControls">
          <button class="pbtn" [ngClass]="isPaused ? 'play' : 'pause'"
            (click)="isPaused ? resumePlayback() : pausePlayback()"
            [title]="isPaused ? 'ادامه' : 'توقف'">
            <i class="fa" [ngClass]="isPaused ? 'fa-play' : 'fa-pause'"></i>
          </button>
          <button class="pbtn reset" (click)="stopPlayback()" title="پایان">
            <i class="fa fa-stop-circle"></i>
          </button>
        </ng-container>
        <button class="pbtn start" *ngIf="!showPlaybackControls" (click)="replayPlayback()">
          <i class="fa fa-play-circle"></i> شروع بازپخش
        </button>
        <div class="player-side">
          <div class="speed-counter" title="سرعت بازپخش">
            <button type="button" class="pbtn mini plus" (click)="increaseSpeed()"
              [disabled]="playbackSpeed >= maxSpeed" title="سریع‌تر">
              <i class="fa fa-plus"></i>
            </button>
            <span class="speed-val">{{ playbackSpeed | faNum }}<small>x</small></span>
            <button type="button" class="pbtn mini minus" (click)="decreaseSpeed()"
              [disabled]="playbackSpeed <= minSpeed" title="کندتر">
              <i class="fa fa-minus"></i>
            </button>
          </div>
          <label class="draw-toggle" for="drawLine">
            <input type="checkbox" id="drawLine" formControlName="drawLine">
            ترسیم دنباله
          </label>
        </div>
      </div>
    </div>
  </div>

</div>

<route-info-modal
  [routeData]="routeData"
  [canRecalculate]="!!access?.bReCalDistance"
  (reloadRequested)="reloadRoute()"
  (recalculateRequested)="recalculateDistance()">
</route-info-modal>
